import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { baseApi } from '../api/baseApi';
import { accountantIbkApi } from '../apiAccountantIbk/accountantIbkApi';
import { clientIbkApi } from '../apiClientIbk/clientIbkApi';
import { ibkApi } from '../apiIbk/ibkApi';
import { ibkLegacyBffApi } from '../apiIbkLegacyBff/ibkLegacyBffApi';
import { viaCepApi } from '../apiViaCep/viaCepApi';
import { zeztraApi } from '../apiZeztra/zeztraApi';
import { encryptTransform } from './cryptoTransform';
import applicationReducer from './slices/applicationSlice';
import billingProductsReducer from './slices/billingProductsSlice';
import hasAccessReducer from './slices/hasAccessSlice';
import permissioningReducer from './slices/permissioningSlice';
import pinCreationReducer from './slices/pinCreationSlice';
import productsReducer from './slices/productsSlice';
import showBalanceReducer from './slices/showBalanceSlice';
import tokensReducer from './slices/tokensSlice';
import userReducer from './slices/userSlice';
import vouchersReducer from './slices/vouchersSlice';
const persistConfig = {
    key: 'ibk-fintech-root',
    storage,
    whitelist: ['tokens', 'user', 'hasAccess', 'vouchers', 'application'],
    transforms: [encryptTransform],
    version: 1,
};
const rootReducer = combineReducers({
    tokens: tokensReducer,
    user: userReducer,
    hasAccess: hasAccessReducer,
    products: productsReducer,
    showBalance: showBalanceReducer,
    vouchers: vouchersReducer,
    application: applicationReducer,
    permissioning: permissioningReducer,
    billingProducts: billingProductsReducer,
    pinCreation: pinCreationReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [zeztraApi.reducerPath]: zeztraApi.reducer,
    [viaCepApi.reducerPath]: viaCepApi.reducer,
    [ibkLegacyBffApi.reducerPath]: ibkLegacyBffApi.reducer,
    [clientIbkApi.reducerPath]: clientIbkApi.reducer,
    [accountantIbkApi.reducerPath]: accountantIbkApi.reducer,
    [ibkApi.reducerPath]: ibkApi.reducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [
                'persist/PERSIST',
                'persist/REHYDRATE',
                'persist/REGISTER',
                'persist/PURGE',
                'persist/FLUSH',
                'persist/PAUSE',
            ],
        },
    })
        .concat(baseApi.middleware)
        .concat(zeztraApi.middleware)
        .concat(viaCepApi.middleware)
        .concat(ibkLegacyBffApi.middleware)
        .concat(clientIbkApi.middleware)
        .concat(accountantIbkApi.middleware)
        .concat(ibkApi.middleware),
    devTools: globalThis.process?.env.NODE_ENV !==
        'production',
});
export const persistor = persistStore(store);
export default store;
